module.exports = __webpack_public_path__ + "static/img/sm_13.7bd8292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_13.png
// module id = YF1h
// module chunks = 0